<template>
  <div>
    <BaseModal>
      <template>
            <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [100, 200]
        }"
        :height="windowHeight"
        fixed-header
        ref="left_table"

        :sort-by="['title']"
        :sort-desc="[false, true]"
    >
<!--        :server-items-length="totalRecords"-->
<!--        :options.sync="options"-->
<!--        @update:options="updateOptions"-->
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
<!--          <v-switch v-model="onlyFailedView" label="only warning" class="ml-5 mt-4"-->
<!--                    color="flamingo"-->
<!--                    @change="onUpdateSearchTerm"></v-switch>-->
        </v-toolbar>
      </template>
      <template v-slot:item.notion_id="{ item }">
        <v-row>
          <v-icon
              v-if="item.notion_id != null"
              color="primary"
              size="20"
              @click="onNotion(item)"
          >
            mdi-alpha-n-box-outline
          </v-icon>
        </v-row>
      </template>
      <template v-slot:item.delivery_date="{ item }">
        <span v-if="item.delivery_date != null">
          {{ item.delivery_date | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:item.real_per_plan="{ item }">
        <BatchRunProgressBar
          v-model="item.real_per_plan"
          :inverse="true"
        ></BatchRunProgressBar>
      </template>
      <template v-slot:item.smd_real_per_plan="{ item }">
        <BatchRunProgressBar
          v-model="item.smd_real_per_plan"
          :inverse="true"
        ></BatchRunProgressBar>
      </template>
      <template v-slot:item.tht_real_per_plan="{ item }">
        <BatchRunProgressBar
          v-model="item.tht_real_per_plan"
          :inverse="true"
        ></BatchRunProgressBar>
      </template>
      <template v-slot:item.smd="{ item}">
        {{ Math.round(item.smd) }}
      </template>
      <template v-slot:item.tht="{ item}">
        {{ Math.round(item.tht) }}
      </template>
      <template v-slot:item.batch_run_end="{ item }">
        <span v-if="item.batch_run_end != null">
          {{ item.batch_run_end | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:body.append="{headers}">
          <tr>
            <td v-for="(header,i) in headers" :key="i">

              <div v-if="header.value == 'smd'">
                {{ getSMDSum }}
              </div>

              <div v-if="header.value == 'tht'">
                {{ getTHTSum }}
              </div>

              <div v-else>
                <!-- empty table cells for columns that don't need a sum -->
              </div>
            </td>
          </tr>
      </template>

    </v-data-table>
      </template>
    </BaseModal>
    <router-view></router-view>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapActions, mapGetters, mapMutations} from "vuex";
import {mapFields} from "vuex-map-fields";
import BatchRunHistoryItem from "@/store/modules/BatchRunHistoryItem";
import BaseModal from "@/components/Base/BaseModal";
import BatchRunProgressBar from "@/components/BatchRun/BatchRunProgressBar";

export default {
  name: 'BatchRunHistoryItem',
  props: ['itemId'],

  components: {
    BaseModal,
    BatchRunProgressBar,
  },

  computed: {
    ...mapGetters('BatchRunHistoryItem', ['getColumns']),
    ...mapFields('BatchRunHistoryItem', ['options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive', 'filters']),
    getSMDSum() {
      return Math.round(this.itemList.reduce((partialSum, item) => partialSum + item.smd, 0))
    },
    getTHTSum() {
      return Math.round(this.itemList.reduce((partialSum, item) => partialSum + item.tht, 0))
    },
  },

  methods: {
    ...
        mapActions('BatchRunHistoryItem', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    ...
        mapMutations('BatchRunHistoryItem', []),

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.filters['delivery_date'] = 'empty'
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions', this.filters)
      this.filters['delivery_date'] = 'empty'
      this.fetchItemList()
    },

    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    }
    ,
    onResize() {
      console.log('this.$route.meta.showModal', this.$route.meta.showModal)
      if (this.$route.meta.hasOwnProperty('showModal') && this.$route.meta.showModal === true)
        this.windowHeight = (window.innerHeight * 0.8 - 100)
      else
        this.windowHeight = (window.innerHeight - 100)
    },
  }
  ,
  created() {
    window.addEventListener("resize", this.onResize)
  }
  ,
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  }
  ,
  async mounted() {
    // console.log('mounted', this.itemId)
    window.addEventListener("resize", this.onResize)
    await this.onResize()
    this.filters = {batch_run_week_id: this.itemId}
    await this.fetchItemList();
  }
  ,

  watch: {
    editedItem: {
      immediate: true,
      handler:

          function (newVal, oldVal) {
            if (this.itemId === null && newVal !== null && newVal.hasOwnProperty('id') && newVal.id !== null)
              this.$router.push({name: 'BatchRunHistoryList_BatchRunHistoryItem', params: {itemId: this.editedItem.id}})
            // console.log('watch editedItem', newVal, oldVal)
          }
    }
  }
  ,

  data() {
    return {
      showModal: false,
      windowHeight: 1200,
      valid: true,
    }
  }
}
</script>

<style scoped lang="scss">
</style>
